export default __webpack_public_path__ + "static/media/dashboard_icon.74891602.svg";